module.exports = __webpack_public_path__ + "img/card-icon-user.f6725905.svg";